var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoNetworkWired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 640 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336 240H624C632.8 240 640 247.2 640 256C640 264.8 632.8 272 624 272H496V320H560C586.5 320 608 341.5 608 368V464C608 490.5 586.5 512 560 512H400C373.5 512 352 490.5 352 464V368C352 341.5 373.5 320 400 320H464V272H176V320H240C266.5 320 288 341.5 288 368V464C288 490.5 266.5 512 240 512H80C53.49 512 32 490.5 32 464V368C32 341.5 53.49 320 80 320H144V272H16C7.164 272 0 264.8 0 256C0 247.2 7.164 240 16 240H304V192H240C213.5 192 192 170.5 192 144V48C192 21.49 213.5 0 240 0H400C426.5 0 448 21.49 448 48V144C448 170.5 426.5 192 400 192H336V240zM400 32H240C231.2 32 224 39.16 224 48V144C224 152.8 231.2 160 240 160H400C408.8 160 416 152.8 416 144V48C416 39.16 408.8 32 400 32zM400 352C391.2 352 384 359.2 384 368V464C384 472.8 391.2 480 400 480H560C568.8 480 576 472.8 576 464V368C576 359.2 568.8 352 560 352H400zM80 352C71.16 352 64 359.2 64 368V464C64 472.8 71.16 480 80 480H240C248.8 480 256 472.8 256 464V368C256 359.2 248.8 352 240 352H80z",
    fill: "#486175",
    className: "fill-primary"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNetworkWired);
export default __webpack_public_path__ + "static/media/ico-network-wired.597c8112c450d43d28737c4a45d7227c.svg";
export { ForwardRef as ReactComponent };